// Auto-generated file created by svgr-cli source svg-template.js
// Do not edit directly
import * as React from 'react'
import type { SVGProps } from 'react'
import { Ref, forwardRef, memo } from 'react'
const SvgIconError = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg xmlns='http://www.w3.org/2000/svg' width={props.width || 16} height={props.height || 16} fill='none' viewBox='0 0 24 24' ref={ref} {...props}>
        <path
            fill='currentcolor'
            d='M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10M8.836 8.836a.934.934 0 0 1 1.324 0l1.836 1.836 1.836-1.836a.937.937 0 0 1 1.324 1.324l-1.836 1.836 1.836 1.836a.937.937 0 0 1-1.324 1.324l-1.836-1.836-1.836 1.836a.937.937 0 0 1-1.324-1.324l1.836-1.836-1.836-1.836a.934.934 0 0 1 0-1.324'
        />
    </svg>
)
const ForwardRef = forwardRef(SvgIconError)
const Memo = memo(ForwardRef)
export default Memo
